// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Slideshow_wrapper__sdXhX","innerWrapper":"Slideshow_innerWrapper__H-XpR","imageWrapper":"Slideshow_imageWrapper__1_ES6","image":"Slideshow_image__2G6ye"};